export const getItem = (item) => {
  return localStorage.getItem(item);
};
